/**
 * SNS Account Management Widget
 *
 * Main widget for managing social media accounts.
 * Orchestrates features and UI components following FSD architecture.
 */

import React from 'react';
import { useAccountSearch } from '@/features/account-search';
import { useAccountForm, AccountFormModal } from '@/features/account-form';
import { useAccountDelete, DeleteAccountModal } from '@/features/account-delete';
import { useCsvImport, useCsvExport } from '@/features/account-csv';
import { AccountHeader } from './ui/AccountHeader';
import { AccountTable } from './ui/AccountTable';

export const SnsAccountManagement: React.FC = () => {
  // Features
  const { state: searchState, data: searchData } = useAccountSearch();
  const formState = useAccountForm();
  const deleteState = useAccountDelete();
  const csvImportState = useCsvImport();
  const csvExportState = useCsvExport();

  return (
    <div className="space-y-6">
      {/* Header with action buttons */}
      <AccountHeader
        onAddClick={formState.openAdd}
        csvImportState={csvImportState}
        csvExportState={csvExportState}
      />

      {/* Search, table, and pagination */}
      <AccountTable
        searchState={searchState}
        searchData={searchData}
        onEdit={formState.openEdit}
        onDelete={deleteState.openConfirm}
        isUpdating={formState.isSubmitting}
        isDeleting={deleteState.isDeleting}
      />

      {/* Modals */}
      <AccountFormModal state={formState} />
      <DeleteAccountModal state={deleteState} />
    </div>
  );
};

SnsAccountManagement.displayName = 'SnsAccountManagement';
